<template>
	<div class="px-2">
		
		<vue-ads-pagination :total-items="pageData.pageInfo.totalItems" :max-visible-pages="2" :items-per-page="pageData.length" :page="pageData.page - 1" @page-change="pageChange" disable-styling class="d-flex align-items-center">
			<template slot-scope="props">
				<select class="lenght-select" @change="pageLength" v-model="length">
					<option value="15">15</option>
					<option value="30">30</option>
					<option value="50">50</option>
					<option value="100">100</option>
				</select>

				Mostrando {{ props.start }} - {{ props.end }} de {{ props.total }} items
			</template>

			<template slot="buttons" slot-scope="props">
				<div
					class="p-2 btn btn-page"
					:class="{
						active: button.active,
						disabled: button.disabled,
					}"
					v-for="(button, key) in props.buttons"
					:key="key"
					@click="pageChange(button.page)"
				>
					
					<svg v-if="button.title == 'previous'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
						<path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
					</svg>
					
					<svg v-if="button.title == 'next'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
						<path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
					</svg>

					<span v-if="button.title != 'previous' && button.title != 'next'">{{ button.html }}</span>
				</div>
			</template>
		</vue-ads-pagination>
	</div>
</template>

<script>
export default {
	name: 'Pagination',
	props: ['pageData'],
	data() {
		return {
			length: null,
		}
	},
	mounted() {
		this.length = this.pageData.length
	},
	methods: {
		pageChange(page) {
			this.$emit('pageChange', page)
		},
		pageLength() {
			this.$emit('pageLength', this.length)
		},
	},
}
</script>
<style scoped>
.lenght-select {
	height: 36px;
	border-radius: 0px;
	border: solid 1px #f3f3f3;
	font-size: 0.8rem;
	margin-right: 12px;
	padding: 0px 8px;
}
.btn-page {
	background-color: #fff;
	border: solid 1px #f3f3f3;
	width: 30px;
	height: 36px;
	border-radius: 0px;
	font-size: 0.8rem;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 2px;
	border-radius: 3px;
}
.btn-page.active {
	background-color: #000000;
	border: solid 1px #f3f3f3;
	color: #fff;
}
.btn-page.disabled {
	background-color: #fff;
	border: solid 1px #f3f3f3;
	opacity: 0.5;
}
</style>
